var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 24,
    viewBox: "0 0 52 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8926 1.10816C36.7763 0.991549 36.6288 0.910936 36.4678 0.875973C36.3068 0.84101 36.1392 0.853177 35.9849 0.911019L16.1386 8.35359C15.7779 8.48752 15.4642 8.72411 15.2362 9.0342C15.0083 9.34429 14.8761 9.7143 14.856 10.0986C14.8358 10.4829 14.9286 10.8647 15.1229 11.197C15.3171 11.5292 15.6044 11.7973 15.9492 11.9682L22.6709 15.329L26.0318 22.0507C26.1927 22.38 26.4433 22.6572 26.7547 22.8504C27.0662 23.0436 27.4259 23.1449 27.7924 23.1427H27.9012C28.2859 23.1258 28.6569 22.9954 28.9676 22.768C29.2783 22.5406 29.5148 22.2263 29.6472 21.8647L37.0898 2.01502C37.1474 1.86089 37.1595 1.69341 37.1246 1.5326C37.0896 1.37179 37.0091 1.22444 36.8926 1.10816ZM28.0418 21.257C28.0261 21.3061 27.9954 21.349 27.954 21.3797C27.9127 21.4105 27.8627 21.4275 27.8112 21.4284C27.7606 21.4314 27.7102 21.4193 27.6664 21.3937C27.6227 21.368 27.5874 21.33 27.5652 21.2845L24.3526 14.8559L28.3212 10.8873C28.4774 10.7256 28.5637 10.5091 28.5618 10.2844C28.5598 10.0597 28.4697 9.84467 28.3108 9.68575C28.1519 9.52683 27.9369 9.43668 27.7121 9.43473C27.4874 9.43277 27.2709 9.51917 27.1092 9.67531L23.1406 13.6439L16.7164 10.4356C16.6698 10.414 16.6308 10.379 16.6043 10.335C16.5778 10.291 16.565 10.2402 16.5677 10.1889C16.5704 10.1376 16.5883 10.0884 16.6193 10.0474C16.6502 10.0064 16.6927 9.97565 16.7412 9.95902L34.8218 3.17902L28.0418 21.257Z",
    fill: "#94A3B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/submit.6d3e9cebb47fbdfd37924d707247285d.svg";
export { ForwardRef as ReactComponent };